import { Component, ViewEncapsulation } from '@angular/core';
import { BlogsComponent } from '@prekog/common-ui';
import { BlogEnum } from './blogEnum';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'pf-blogs',
    templateUrl: './bloglist.component.html',
    styleUrls: ['./bloglist.component.scss'],
    standalone: true,
    imports: [BlogsComponent]
})
export class BlogListComponent {
    type = BlogEnum.NEWS;
}
